<mat-toolbar id="page" class="full-flex">
  <div class="wrapper">
    <a target="_blank" href={{termsLink}}>Terms of Use and Privacy Policy</a>
    <p>© 2020 RECEIPTIUM. All rights reserved.</p>
  </div>
</mat-toolbar>